const Kontakt = () => import("@views/app/contact/contact.vue");

export const kontaktRoutes = [
    {
        component: Kontakt,
        name: "kontakt",
        path: "kontakt"
    }
];